module.exports = __webpack_public_path__ + "static/work-together-blue-d58fdb7c6090947e9b56f68098540c8b.svg";